/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const camera = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M15 12.408a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-6.91a1 1 0 0 1 1-1h2.555c.168 0 .33-.066.45-.185L6.54 2.776a.636.636 0 0 1 .45-.186h2.018c.169 0 .33.067.45.186l1.536 1.537a.64.64 0 0 0 .45.186H14a1 1 0 0 1 1 1v6.909Z"
    />
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M9.91 8.635a1.91 1.91 0 1 1-3.82 0 1.91 1.91 0 0 1 3.82 0Z"
    />
  </svg>
)
export default camera
